import { render } from "./TableOfContentsItem.vue?vue&type=template&id=ebf4d8f0&ts=true"
import script from "./TableOfContentsItem.vue?vue&type=script&lang=ts"
export * from "./TableOfContentsItem.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__